import { render } from "./Localidad_Localidad.vue?vue&type=template&id=09a5a962"
import script from "./Localidad_Localidad.vue?vue&type=script&lang=js"
export * from "./Localidad_Localidad.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__